import PointsTag from './PointsTag';

export default PointsTag;
